import React from 'react'
import '../styles/containerSection2.css'
import { NavLink } from 'react-router-dom'

function SectionComp2() {
    return (
        <div className='container-xxxl container_services py-3'>
            <div className='zoom-bg2'></div>

            <div className='d-flex justify-content-evenly align-items-center container_services_sec'>
                <div className='tittle_section_2 text-center'>
                    <span>Nuestros </span><span className='fw-bold'>servicios</span>
                    <div className='tittle_section_2_li mt-3 mb-3'>
                        <div>Urgencias legales</div>
                        <div>Asistencia y defensa jurídica</div>
                        <div>Representación en calidad de demandante y demandado</div>
                        <div>Conciliaciones</div>
                        <div>Cortes marciales</div>
                        <div>Proceso ante la JEP</div>
                        <div>Fraude procesal</div>
                        <div>Entre otros...</div>
                    </div>
                </div>

                <div className='tittle_section_2 text-center'>

                    <span>Servicios </span><span className='fw-bold'>Complementarios</span>

                    <div className='tittle_section_2_li mt-3 mb-5'>
                        <div>Juntas médicas</div>
                        <div>Planificación patrimonial</div>
                        <div>Procesos disciplinarios</div>
                        <div>Entre otros...</div>
                    </div>

                    <NavLink to="/services" className="zoom-container-buttom2 mt-2">Más información {` ➔`}</NavLink>
                </div>
            </div>
        </div>
    )
}

export default SectionComp2
